import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';

const GetComponent = (dev) => {
  switch (dev) {
    case "dev":
      return {
        payin: () => import('../views/cashier_auto/payin.vue'),
        payout: () => import('../views/cashier_auto/payout.vue')
      }
    case "pretest":
      return {
        payin: () => import('../views/cashier_auto/payin.vue'),
        payout: () => import('../views/cashier_auto/payout.vue')
      }
    case "sandbox":
    case "sunpaysandbox":
      return {
        // payin: () => import('../views/cashier_sandbox/payin.vue'),
        // payout: () => import('../views/cashier_sandbox/payout.vue')
        payin: () => import('../views/cashier_auto/payin.vue'),
        payout: () => import('../views/cashier_auto/payout.vue')
      }
    case "prod":
    case "sunpayprod":
      return {
        // payin: () => import('../views/cashier_iframe/payin.vue'),
        // payout: () => import('../views/cashier_iframe/payout.vue')
        payin: () => import('../views/cashier_auto/payin.vue'),
        payout: () => import('../views/cashier_auto/payout.vue')
      }
    default: {
      return {
        payin: () => import('../views/cashier_fixed/payin.vue'),
        payout: () => import('../views/cashier_fixed/payout.vue')
      }
    }
  }
}

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'index',
    component: () => import('../views/pay/annex/index.vue'),
  },
  {
    path: '/payment',
    name: 'payment',
    component: () => import('../views/payment/index.vue'),
  },
  {
    path: '/paylink',
    name: 'paylink',
    component: () => import('../views/paylink/index.vue'),
  },
  {
    path: '/cashier/payin',
    name: 'payin',
    // component: GetComponent(process.env.VUE_APP_BUILD_ENV).payin,
    component: () => import('../views/checkout/payin.vue'),
  },
  {
    path: '/cashier/payout',
    name: 'payout',
    // component: GetComponent(process.env.VUE_APP_BUILD_ENV).payout,
    component: () => import('../views/checkout/payout.vue'),
  },
  {
    path: '/landing',
    name: 'landing',
    // component: GetComponent(process.env.VUE_APP_BUILD_ENV).payout,
    component: () => import('../views/landing/index.vue'),
  },
];

if (process.env.VUE_APP_BUILD_ENV.indexOf('sandbox') !== -1) {
  routes.push({
    path: '/cashier/example',
    name: 'example',
    component: () => import('../views/cashier_sandbox/example.vue'),
  })
}

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  next();
})

export default router;
